"use strict";

import Phaser from 'phaser';

import UI from '../ui';

export default class extends Phaser.GameObjects.Group {
  constructor(config) {
    super(config.scene);
    this.setup();
  }

  setup() {
    this.bg = this.scene.add.sprite(1, 1, 'ui-scoreboard-bg');
    this.bg.setScrollFactor(0);
    this.bg.setDepth(UI.depth);
    this.bg.setOrigin(0, 0);
    this.add(this.bg);

    // x, y, text, fontConfig
    this.scoreText = this.scene.add.text(15, 6, '0', { fontFamily: 'Arial', fontSize: 4, color: '#f2ff09' });
    this.scoreText.setAlign('right');
    this.scoreText.setOrigin(1, 0.5);
    this.scoreText.setScrollFactor(0);
    this.scoreText.setDepth(UI.depth); // Move to top of z-index

    this.add(this.scoreText);

    this.scene.add.existing(this);
  }

  update(score) {
    this.scoreText.setText(score.toString());
  }
}